import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { push } from "firebase/database";

const hasValidPushToken = (token) => {
    return !!(token && token !== 'web' && token !== 'token_error' && token !== 'init');
};

export const RequestPushMsg = (token, data) => {
    const {
        config
    } = firebase;
    
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/send_notification`;

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
    .then((response) => {

    })
    .catch((error) => {
        console.log(error)
    });
}

export const sendWorkflowNotification = async ({ uid, pushToken, title, msg, screen, params }) => {
    try {
        if (hasValidPushToken(pushToken)) {
            RequestPushMsg(pushToken, {
                title,
                msg,
                screen: screen || 'Notifications',
                params: params || {}
            });
            return;
        }
        if (uid) {
            await push(firebase.userNotificationsRef(uid), {
                dated: new Date().getTime(),
                title,
                msg,
                screen: screen || 'Notifications',
                params: params || {}
            });
        }
    } catch (error) {
        console.log(error);
    }
}
